<template>
  <div id="show-client-portal" class="no-container">
    <div id="content-start-anchor"></div>
    <div v-if="isLoaded && clientPortal != null">
      <v-tabs-items
        v-model="global.selectedAppTab"
        class="pa-3 adapted-window"
        :style="{
          backgroundColor: 'transparent',
          height: screenHeight > 0 ? `${screenHeight}px` : 'auto',
          overflowY: 'auto',
        }"
      >
        <v-tab-item class="full-height">
          <informations-tab :client-portal="clientPortal"></informations-tab>
        </v-tab-item>
        <v-tab-item
          v-if="clientPortal.portalConfiguration != null"
          class="full-height"
        >
          <presentation-tab
            :client-portal="clientPortal"
            :selectedTab="global.selectedAppTab"
          ></presentation-tab>
        </v-tab-item>
        <v-tab-item class="pt-3 pb-1 full-height">
          <configuration-tab :client-portal="clientPortal"></configuration-tab>
        </v-tab-item>
        <v-tab-item class="pt-3 pb-1">
          <catalogue-tab :client-portal="clientPortal"></catalogue-tab>
        </v-tab-item>
        <v-tab-item class="pt-3 pb-1">
          <traduction-tab :client-portal="clientPortal"></traduction-tab>
        </v-tab-item>
        <v-tab-item class="pt-3 pb-1">
          <technique-tab :client-portal="clientPortal"></technique-tab>
        </v-tab-item>
        <v-tab-item class="pt-3 pb-1">
          <usage-tab :client-portal="clientPortal"></usage-tab>
        </v-tab-item>
      </v-tabs-items>
    </div>
    <div v-else>
      <LoadingDialog />
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import {
  onMounted,
  toRefs,
  ref,
  watch,
  onUnmounted,
} from "@vue/composition-api";
import { useClientPortal } from "../composables/client-portal";
import router from "../router";
import { useTitle } from "@/composables/title";
import { date } from "@/composables/date";
import global from "@/composables/global";
import LoadingDialog from "@/components/General/LoadingDialog.vue";
import InformationsTab from "./clientPortal/InformationsTab.vue";
import PresentationTab from "./clientPortal/PresentationTab.vue";
import ConfigurationTab from "./clientPortal/ConfigurationTab.vue";
import UsageTab from "./clientPortal/UsageTab.vue";
import TechniqueTab from "./clientPortal/TechniqueTab.vue";
import TraductionTab from "./clientPortal/TraductionTab.vue";
import CatalogueTab from "./clientPortal/CatalogueTab.vue";
import { useIframePreview } from "@/composables/iframe-preview";

export default {
  components: {
    LoadingDialog,
    InformationsTab,
    PresentationTab,
    ConfigurationTab,
    UsageTab,
    TechniqueTab,
    TraductionTab,
    CatalogueTab,
  },
  setup() {
    /* Import des API */
    const { setTitle, setIcon } = useTitle();
    const {
      currentClientPortal: clientPortal,
      showClientPortal,
      updatePortalConfiguration,
      data,
    } = useClientPortal();
    const { getInternationalDate } = date();

    /* Cycle de vie */
    onMounted(async () => {
      global.tabsDisabled = true;
      global.appTabs = [
        "Informations",
        "Présentation",
        "Configuration",
        "Catalogue",
        "Traduction",
        "Technique",
        "Usage",
      ];
      await showClientPortal(clientId);
      setTitle(
        `${clientPortal.value.passmanId} - ${clientPortal.value.description}`
      );
      setIcon("portails");
      global.tabsDisabled = false;
      isLoaded.value = true;
      computeAvailableScreenSpace("content-start-anchor");
      window.addEventListener("resize", function () {
        computeAvailableScreenSpace("content-start-anchor");
      });
    });
    onUnmounted(() => {
      global.appTabs = [];
      global.selectedAppTab = 0;
    });

    /* Variables */
    const clientId = router.currentRoute.params.id;
    const isLoaded = ref(false);
    const screenHeight = ref(0);

    /* Computed */

    /* Méthodes */
    const computeAvailableScreenSpace = function (domId) {
      const anchor = document.getElementById(domId);
      if (anchor) {
        const anchorPosition = anchor.getBoundingClientRect().bottom;
        const totalScreenHeight = window.innerHeight;
        screenHeight.value = totalScreenHeight - anchorPosition;
      }
    };

    const { reloadPreview } = useIframePreview();

    /* Watchers */
    watch(
      () => global.selectedAppTab,
      () => {
        Vue.nextTick(function () {
          // DOM updated
          computeAvailableScreenSpace("content-start-anchor");
        });

        if (global.selectedAppTab == 1 || global.selectedAppTab == 2) {
          reloadPreview();
        }
      }
    );

    return {
      clientPortal,
      clientId,
      updatePortalConfiguration,
      ...toRefs(data),
      isLoaded,
      global,
      screenHeight,
      getInternationalDate,
    };
  },
};
</script>
<style>
.noteCard:hover .nodeBtn {
  visibility: visible;
}
.theme--light.v-tabs-items {
  background-color: #eaeaea;
}
</style>
